import { KeyValue } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { addDays, dateDiff, fechaCV, fFecha, inicioAnio, inicioMes, inicioMesActual, inicioQuincena, inicioQuincenaActual, inicioSemanaActual, obtenerDiaSemana, soloDia, soloHoy, TipoDateDiff } from 'src/app/core/Funciones/fFecha';
import { fechaT } from 'src/app/core/Funciones/fTexto';
import { mostrarSwalError, mostrarSwalToast } from 'src/app/core/Funciones/funciones';
import { AccesoDatosService } from 'src/app/core/services/acceso-datos.service';
import { PDFService } from 'src/app/core/services/pdfmake.service';
import { HorarioDialogComponent } from 'src/app/horarios/horario-dialog/horario-dialog.component';
import { IEmpleados, nombreEmpleado } from 'src/app/models/empleados';
import { IEmpresa } from 'src/app/models/empresa';
import { IHorarios, IHorariosEmpleado, IHorariosIncidencias, IHorariosTotal } from 'src/app/models/horarios';
import { $tipoIncapacidad, $tipoManejoIncidenciaUsuario, convertirAHorarioIncidenciaDetalle, convertirHorarioIncidenciaADetalle, IAccesoIncidenciasUsuario, IAccesoIncidenciasUsuarioCargar, TipoManejoIncidencia } from 'src/app/models/incidencias';
import { $tipoIncidenciaFiltro, $tipoPeriodoReporteOrden, $tipoPeriodoValidacion } from 'src/app/models/periodos';
import { IRespuestaChecker, IRespuestaCheckerId } from 'src/app/models/resultadoActualiza';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-empleados-validar-incidencias',
  templateUrl: './empleados-validar-incidencias.component.html',
  styleUrls: ['./empleados-validar-incidencias.component.scss']
})
export class EmpleadosValidarIncidenciasComponent implements OnInit {
  public esDebugger: boolean = false;
  public estaCargando: boolean = true;
  public esListado: boolean = false;
  public empresa!: IEmpresa;
  public incidenciasUsuarioOriginal: IAccesoIncidenciasUsuario[] = [];
  public incidenciasUsuario: IAccesoIncidenciasUsuario[] = [];
  public nuevaIncidencia: IAccesoIncidenciasUsuario = new IAccesoIncidenciasUsuario();

  // agregar nueva incidencia
  public periodo: string = 'mes0';
  public tipoPeriodoReporte = $tipoPeriodoValidacion;
  public tipoPeriodoReporteOrden = $tipoPeriodoReporteOrden;
  public inicioPersonalizado: string = '';
  public finPersonalizado: string = '';
  public diasPeriodo: number = 0;
  public agregarNuevaIncidencia: boolean = false;
  public agregarIncidenciaMasiva: boolean = false;
  public tipoManejoIncidencia = $tipoManejoIncidenciaUsuario;
  public tipoIncapacidad = $tipoIncapacidad;
  public titleIncidencia: string = 'Validación de incidencias';
  public incidencia: IHorariosIncidencias =  new IHorariosIncidencias();
  public incidenciaCambio: IHorariosIncidencias =  new IHorariosIncidencias();

  public inicioPeriodo: Date;
  public finPeriodo: Date;
  public rangoPersonalizado = new FormGroup({
    desde: new FormControl<Date | null>(null),
    hasta: new FormControl<Date | null>(null),
  });


  // empleado
  public empleadoSeleccionado: IEmpleados | undefined = undefined;
  public empleados: IEmpleados[] = [];
  public empleadosTotales: IEmpleados[] = [];
  public mostrarBajas: boolean = false;
  public soloConsulta: boolean = false;

  public displayedColumns: string[] = ['nombre', 'inicio', 'fin', 'tipoMovimiento', 'tipoIncapacidad', 'diasVacaciones', 'tipoHorario', 'observaciones'];
  public incidenciasObs!: Observable<any>;
  public dataSource: MatTableDataSource<IAccesoIncidenciasUsuario> = new MatTableDataSource<IAccesoIncidenciasUsuario>(this.incidenciasUsuario);
  public tipoIncidenciaSeleccionado: number = 100;
  public tiposDeIncidencias = $tipoIncidenciaFiltro;
  public fechaValidacionTxt: string = '';
  public horariosEmpleado: IHorariosEmpleado[] = [];
  public horariosIncidencias: IHorariosIncidencias[] = [];
  public horario: IHorarios = new IHorarios();
  private incidenciasCargadas = false;
  private horariosCargados = false;
  public diasTotalesVacaciones: number = 0;
  public etiquetaAgrupar: string = 'Agrupador';
  public grupoEmpleados: string[] = [];
  public agrupadorSeleccionado: string | undefined = undefined;
  public areasEmpleados: string[] = [];
  public areaSeleccionada: string | undefined = undefined;
  public movimientosParaMostrar: { key: number; value: string }[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EmpleadosValidarIncidenciasComponent>,
    private accesoDatosService: AccesoDatosService,
    private pdfService: PDFService,
    private paginadoLabel: MatPaginatorIntl,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { inicio: Date, fin: Date, periodo: string, empleado: IEmpleados, soloConsulta: boolean },
  ) {
    this.inicioPeriodo = inicioMesActual();
    this.finPeriodo = addDays(new Date(this.inicioPeriodo.getFullYear(), this.inicioPeriodo.getMonth() + 1, 1), -1);
    this.cargarDatos();
    this.paginadoLabel.itemsPerPageLabel = 'Incidencias por página';
  }

  public cargarDatos() {
    this.estaCargando = true;
    this.agregarNuevaIncidencia = false;
    this.esDebugger = this.accesoDatosService.getModoDebug();
    this.movimientosParaMostrar = this.reportesParaMostrarGet;

    this.accesoDatosService.empleadosListado().subscribe(
      (empleados: IEmpleados[]) => {
        this.empleados = empleados;
        this.empleadosTotales = empleados;
        this.areasEmpleados = Array.from(new Set(this.empleados.map(e => e.area).filter(area => !!area)));
        this.aplicarFiltrosEmpleados();
      },
      (error) => {
        this.accesoDatosService.logAgrega2("Error al cargar los datos de los empleados");
        console.error(error);
        this.empleados = [];
        this.empleadosTotales = [];
      }
    );

    this.accesoDatosService.incidenciasUsuarioCargar({inicio: this.inicioPeriodo, inicioTxt: fechaT(this.inicioPeriodo), fin: this.finPeriodo, finTxt: fechaT(this.finPeriodo)}).subscribe(
      (respuesta: IAccesoIncidenciasUsuarioCargar) => {
        if (respuesta.code == 100) {
          this.empresa = respuesta.empresa;
          this.etiquetaAgrupar = !respuesta.empresa.etiquetaGrupo ? 'Agrupador' : respuesta.empresa.etiquetaGrupo;
          this.incidenciasUsuarioOriginal = respuesta.incidencias;
          this.dataSource.data = respuesta.incidencias;
          this.aplicarFiltrosIncidencias();
          this.incidenciasCargadas = true;
          this.verificarDatosCompletos();
          this.estaCargando = false;
          return;
        }
        mostrarSwalError('Validación de Incidencias', `Error al cargar las incidencias, respuesta del servidor: ${respuesta.code}, ${respuesta.mensaje}`)
      },
      (error) => {
        let err: string = JSON.stringify(error);
        this.accesoDatosService.logAgrega2(err);
        mostrarSwalError('Validación de Incidencias', `Error al cargar las incidencias, ${err}`);
      }
    );

    this.accesoDatosService.horariosEmpleadosConIncidencias().subscribe(
      (horariosTotales: IHorariosTotal) => {
        this.horariosEmpleado = horariosTotales.horariosEmpleados;
        this.horariosIncidencias = horariosTotales.horariosIncidencias;
        this.horariosCargados = true;
        this.verificarDatosCompletos();
      },
      (error: HttpErrorResponse) => {
        mostrarSwalError('Error al cargar el horario', 'Error al cargar el horario del empleado');
        this.ponerTxtEnConsola(`Conectando con el servidor. Cargar incidencias.`);
        let err: string = JSON.stringify(error);
        this.ponerTxtEnConsola(err);
      }
    );

    this.accesoDatosService.empleadosGrupos().subscribe(
      (grupos: string[]) => {
        this.grupoEmpleados = grupos;
      },
      (error) => {
        let errorTxt: string = error.error;
        console.error(errorTxt);
      }
    );
  }

  private verificarDatosCompletos() {
    if (this.incidenciasCargadas && this.horariosCargados) {
      this.obtenerHorario();
      this.calcularDiasVacaciones();
      this.estaCargando = false;
    }
  }

  public guardarIncidencia() {
    if (!this.inicioPersonalizado) {
      mostrarSwalToast('No se ha especificado la fecha de inicio de la nueva incidencia', 'error');
      return;
    }
    if (!this.finPersonalizado) {
      mostrarSwalToast('No se ha especificado la fecha de terminación de la nueva incidencia', 'error');
      return;
    }

    this.nuevaIncidencia.inicio = fechaCV(this.inicioPersonalizado);
    this.nuevaIncidencia.fin = fechaCV(this.finPersonalizado);

    if (this.nuevaIncidencia.inicio < new Date(2000, 0, 1)) {
      mostrarSwalToast(`La fecha de inicio de la nueva incidencia (${fFecha(this.nuevaIncidencia.inicio, 'fsl')}) no es válida`, 'error');
      return;
    }

    if (this.nuevaIncidencia.fin > new Date(new Date().getFullYear() + 10, 0, 1)) {
      mostrarSwalToast(`La fecha de terminación de la nueva incidencia (${fFecha(this.nuevaIncidencia.inicio, 'fsl')}) no es válida`, 'error');
      return;
    }

    if (this.nuevaIncidencia.inicio > this.nuevaIncidencia.fin) {
      mostrarSwalToast(`La fecha de terminación de la nueva incidencia (${fFecha(this.nuevaIncidencia.inicio, 'fsl')}) no es válida, es menor a la fecha de inicio`, 'error');
      return;
    }

    if (!this.empleadoSeleccionado) {
      mostrarSwalToast(`Debe seleccionar un empleado para la nueva incidencia`, 'error');
      return;
    }

    if (!this.nuevaIncidencia.tipoManejoIncidencia) {
      mostrarSwalToast(`Debe seleccionar un Tipo de Movimiento para la nueva incidencia`, 'error');
      return;
    }

    if (this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.Incapacidad) {
      if (!this.nuevaIncidencia.tipoIncapacidad) {
        mostrarSwalToast(`Debe seleccionar un Tipo de Incapacidad para la nueva incidencia`, 'error');
        return;
      }

      if (!this.nuevaIncidencia.observaciones) {
        mostrarSwalToast(`Debe especificar un folio para la Incapacidad de la nueva incidencia`, 'error');
        return;
      }
    }

    this.nuevaIncidencia.idEmpresa = this.empresa.id;
    this.nuevaIncidencia.idEmpleado = +this.empleadoSeleccionado.id;

    if (this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.PermisoPorHoras) {
      this.modificarHorarioIncidencia();
    }

    this.accesoDatosService.incidenciasUsuarioGuardar(this.nuevaIncidencia).subscribe(
      (respuesta: IRespuestaCheckerId) => {
        if (respuesta.code !== 100) {
          mostrarSwalError('Validación de Incidencias', `Error al guardar las incidencias: ${respuesta.code}, ${respuesta.mensaje}`);
          return;
        }

        if (this.nuevaIncidencia.tipoManejoIncidencia != TipoManejoIncidencia.PermisoPorHoras && this.nuevaIncidencia.tipoManejoIncidencia != TipoManejoIncidencia.CambioTurno) {
          mostrarSwalToast(`${respuesta.mensaje}`, 'success');
          this.cargarDatos();
          this.empleadoSeleccionado = undefined;
          this.nuevaIncidencia.observaciones = '';
          this.agregarNuevaIncidencia = false;
          this.nuevaIncidencia.tipoManejoIncidencia = TipoManejoIncidencia.Ninguno;
          this.adjustDialogSize();
          return;
        }

        if (this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.PermisoPorHoras) {
          this.incidencia.idIncidenciaUsuario = 0;
          if (!!respuesta.id) this.incidencia.idIncidenciaUsuario = +respuesta.id;
          this.accesoDatosService.horarioIncidenciaModificar(this.incidencia).subscribe(
            (respuesta: IRespuestaChecker) => {
              if (respuesta.code === 100) {
                mostrarSwalToast(`${respuesta.mensaje}`, 'success');
                console.log(`Cambio de turno aplicado correctamente`);
              } else {
                mostrarSwalError('Error', `Error al cambiar de turno: ${respuesta.code}, ${JSON.stringify(respuesta)}`);
              }
            },
            (error) => {
              console.error('Error al cambiar de turno:', error);
              const errTxt = typeof error?.error === 'object' ? JSON.stringify(error.error) : (error?.error || error?.message || 'Error desconocido');
              mostrarSwalError('Error al cambiar de turno', errTxt);
            }, () => {
              mostrarSwalToast(`${respuesta.mensaje}`, 'success');
              this.cargarDatos();
              this.empleadoSeleccionado = this.data?.empleado;
              this.agregarNuevaIncidencia = false;
              this.nuevaIncidencia.tipoManejoIncidencia = TipoManejoIncidencia.Ninguno;
              this.adjustDialogSize();
            }
          );
        }

        if (this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.CambioTurno) {
          this.incidencia.idIncidenciaUsuario = 0;
          if (!!respuesta.id) this.incidencia.idIncidenciaUsuario = +respuesta.id;
          this.accesoDatosService.horarioIncidenciaCambio(this.incidencia, this.incidenciaCambio).subscribe(
            (respuesta: IRespuestaChecker) => {
              if (respuesta.code === 100) {
                mostrarSwalToast(`${respuesta.mensaje}`, 'success');
                console.log(`Suplencia de turno aplicada correctamente`);
              } else {
                mostrarSwalError('Error', `Error en la suplencia de turno: ${respuesta.code}, ${JSON.stringify(respuesta)}`);
              }
            },
            (error) => {
              console.error('Error en la suplencia de turno:', error);
              const errTxt = typeof error?.error === 'object' ? JSON.stringify(error.error) : (error?.error || error?.message || 'Error desconocido');
              mostrarSwalError('Error en la suplencia de turno', errTxt);
            }, () => {
              mostrarSwalToast(`${respuesta.mensaje}`, 'success');
              this.cargarDatos();
              this.empleadoSeleccionado = this.data?.empleado;
              this.agregarNuevaIncidencia = false;
              this.nuevaIncidencia.tipoManejoIncidencia = TipoManejoIncidencia.Ninguno;
              this.adjustDialogSize();
            }
          );
        }
      },
      (error) => {
        const errTxt = error?.error || error?.message || 'Error desconocido';
        this.accesoDatosService.logAgrega2(JSON.stringify(error));
        mostrarSwalError('Error al guardar las incidencias', errTxt);
      }
    );
  }

  public manejarHorarioSeleccionado(data: any) {
    this.modificarHorarioIncidencia();
  }

  public modificarHorarioIncidencia() {
    const detalle = convertirAHorarioIncidenciaDetalle(this.horario, this.fechaValidacionTxt);
    let esDescanso = this.horario.detalles[0].diasDescanso.length > 0 && this.horario.detalles[0].diasDescanso.includes(this.fechaValidacionTxt);
    this.incidencia = {
      id: this.nuevaIncidencia.id,
      idEmpresa: this.nuevaIncidencia.idEmpresa,
      idEmpleado: this.nuevaIncidencia.idEmpleado,
      inicio: this.nuevaIncidencia.inicio,
      inicioTxt: this.nuevaIncidencia.inicioTxt,
      fin: this.nuevaIncidencia.fin,
      finTxt: this.nuevaIncidencia.finTxt,
      horario: detalle, // usar esta función ++ convertirAHorarioIncidenciaDetalle ++ se debe enviar los datos de horario del día ejemplo: '[ {"horaEntrada": 16.5, "horaSalida": 18, "nocturno": false} ]'
      esDescanso: esDescanso,
      esNocturno: this.horario.nocturno,
      horarioDia: this.horario.detalles[0].horariosSemana[this.fechaValidacionTxt],
      idIncidenciaUsuario: 0,
      tipoHorario: this.horario.tipoHorario,
      manejoHorario: this.horario.manejoHorario,
    };
    if (!environment.production || this.esDebugger) console.log(`Modificar horario de la incidencia:`, this.incidencia);
  }

  public eliminarIncidencia(incidencia: IAccesoIncidenciasUsuario) {
    Swal.fire({
      title: "Eliminar incidencia",
      html: `¿Estás seguro de que deseas eliminar la incidencia de ${incidencia.nombreEmpleado}?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar"
    }).then((resultado) => {
      if (!resultado.isConfirmed) return;
      this.accesoDatosService.incidenciasUsuarioEliminar(incidencia).subscribe(
        (respuesta: IRespuestaChecker) => {
          if (respuesta.code !== 100) {
            mostrarSwalError('Error', `Error al eliminar la incidencia, respuesta del servidor: ${respuesta.code}, ${respuesta.mensaje}`);
            return;
          }

          mostrarSwalToast(`Incidencia eliminada correctamente`, 'success');
          this.agregarNuevaIncidencia = !this.agregarNuevaIncidencia;
          this.cargarDatos();
        },
        (error) => {
          this.accesoDatosService.logAgrega2(JSON.stringify(error));
          const errTxt = error?.error || error?.message || 'Error desconocido';
          mostrarSwalError('Error al eliminar la incidencia', errTxt);
        }
      );
    });
  }

  private ponerTxtEnConsola(txt: string) {
    console.log(txt);
    this.accesoDatosService.logAgrega(txt);
  }

  public aplicarFiltrosEmpleados() {
    if (this.mostrarBajas) {
      this.empleados = this.empleadosTotales;
    }  else {
      this.empleados = this.empleadosTotales.filter(x => !x.baja || x.baja.getTime() <= new Date(1900, 1, 1).getTime()).sort(
        (a, b) => +a.numero - +b.numero || a.nombre?.toLowerCase().localeCompare(b.nombre?.toLowerCase())
      );
    }

    this.empleados.forEach(empleado => {
      (empleado as any)['nombreCompleto'] = `${empleado.nombre} ${empleado.paterno ? empleado.paterno : ''} ${empleado.materno ? empleado.materno : ''}`;
    });

    this.empleados = this.empleados;
  }

  public aplicarFiltrosIncidencias() {
    this.adjustDialogSize();
    const tipoSeleccionado: number = this.tipoIncidenciaSeleccionado ? +this.tipoIncidenciaSeleccionado : 0;

    this.incidenciasUsuario = this.incidenciasUsuarioOriginal.filter(x => tipoSeleccionado === 100 || x.tipoManejoIncidencia === tipoSeleccionado);

    if (this.empleadoSeleccionado && this.empleadoSeleccionado.id) {
      const idEmpleado: number = +this.empleadoSeleccionado.id;
      this.incidenciasUsuario = this.incidenciasUsuario.filter(x => x.idEmpleado === idEmpleado);
      if (this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.PermisoPorHoras || this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.CambioTurno) {
        this.cambiarTipoMovimiento();
      }
    }

    if (this.agrupadorSeleccionado) {
      this.incidenciasUsuario = this.incidenciasUsuario.filter(inc =>
        this.empleados.find(emp => +emp.id === inc.idEmpleado && emp.grupo === this.agrupadorSeleccionado)
      );
    }
    if (this.areaSeleccionada) {
      this.incidenciasUsuario = this.incidenciasUsuario.filter(inc =>
        this.empleados.find(emp => +emp.id === inc.idEmpleado && emp.area === this.areaSeleccionada)
      );
    }

    this.incidenciasUsuario = this.incidenciasUsuario.sort((a, b) => {
      const finA = a.fin ? a.fin.getTime() : 0;
      const finB = b.fin ? b.fin.getTime() : 0;
      const inicioA = a.inicio ? a.inicio.getTime() : 0;
      const inicioB = b.inicio ? a.inicio.getTime() : 0;
      return finB - finA || inicioA - inicioB || a.nombreEmpleado.localeCompare(b.nombreEmpleado);
    });

    this.dataSource.data = [...this.incidenciasUsuario];
    this.calcularDiasVacaciones();
  }


  public formatoFecha(fechaTxt: Date | undefined): string {
    if (!fechaTxt) {
      return '-';
    }
    const fecha = new Date(fechaTxt);
    return fFecha(fecha, "fsl");
  }

  public formatoFechaCorto(fechaTxt: Date | undefined): string {
    if (!fechaTxt) {
      return '-';
    }
    const fecha = new Date(fechaTxt);
    return fFecha(fecha, "fc");
  }

  public formatoFechaInput(fechaTxt: string | undefined): string {
    if (!fechaTxt) {
      return '-';
    }
    const fecha = new Date(fechaTxt);
    return fFecha(fecha, "fsl");
  }

  public limpiarFiltro() {
    this.empleadoSeleccionado = undefined;

    if (!this.agregarNuevaIncidencia) {
      if (this.periodo == 'anioEmpleado') {
        this.periodo = 'mes0';
        this.cambiarPeriodo();
      }
      this.cargarDatos();
    }
  }

  public toggleAgregarNuevaIncidencia() {
    this.agregarNuevaIncidencia = !this.agregarNuevaIncidencia;
    this.agregarIncidenciaMasiva = false;
    this.nuevaIncidencia.tipoManejoIncidencia = TipoManejoIncidencia.Ninguno;
    if (this.agregarNuevaIncidencia) {
      this.titleIncidencia = 'Agregar incidencia';
    } else {
      this.titleIncidencia = 'Validación de incidencias';
    }
    this.adjustDialogSize();
  }

  public toggleIncidenciaMasiva() {
    this.agregarNuevaIncidencia = false;
    this.agregarIncidenciaMasiva = true;
    this.titleIncidencia = 'Agregar incidencia masiva';
    this.adjustDialogSize();
  }

  private adjustDialogSize() {
    let width = '70rem';
    let height = '90vh';

    if (this.agregarNuevaIncidencia) {
      width = '40rem';
      height = 'auto';
    }

    if (this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.PermisoPorHoras || this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.CambioTurno) {
      width = '70rem';
      height = '90vh';
    }

    this.dialogRef.updateSize(width, height);
  }

  public calcularDias() {
    if (this.inicioPersonalizado && this.finPersonalizado) {
      const fechaInicio = fechaCV(this.inicioPersonalizado);
      const fechaFin = fechaCV(this.finPersonalizado);

      if (fechaInicio && fechaFin) {
        const diferencia = fechaFin.getTime() - fechaInicio.getTime();
        this.diasPeriodo = Math.ceil(diferencia / (1000 * 3600 * 24)) + 1;
      } else {
        this.diasPeriodo = 0;
      }
    } else {
      this.diasPeriodo = 0;
    }
  }

  public nombreCompleto(empleado: IEmpleados) {
    return nombreEmpleado(empleado);
  }

  public valuePeriodoAscOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return this.tipoPeriodoReporteOrden[a.key] - this.tipoPeriodoReporteOrden[b.key];
  };

  // public exportarExcel() {
  //   let títulos: TítulosExcel = {
  //     titulo1: `Validaciones de incidencias ${this.empresa.nombre}`,
  //     titulo2: `Fecha de expedición: ${this.formatoFecha(new Date())}`,
  //     titulo3: undefined,
  //     titulo4: undefined
  //   };

  //   let columnas: ColumnaExcel[] = [
  //     { header: 'Nombre', key: 'nombre', width: 30, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
  //     { header: 'Inicio', key: 'inicio', width: 20, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
  //     { header: 'Terminación', key: 'fin', width: 20, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
  //     { header: 'Tipo de movimiento', key: 'tipoMovimiento', width: 20, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
  //     { header: 'Tipo de incapacidad', key: 'tipoIncapacidad', width: 20, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
  //     { header: 'Observaciones', key: 'observaciones', width: 20, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
  //   ];

  //   let títuloColumnas: string[] = columnas.map(columna => columna.header);

  //   let renglones: RenglonesExcel[] = this.incidenciasUsuario.map(incidencia => {
  //     let datosRenglon: any[] = [
  //       incidencia.nombreEmpleado,
  //       this.formatoFecha(incidencia.inicio),
  //       this.formatoFecha(incidencia.fin),
  //       this.tipoManejoIncidencia[incidencia.tipoManejoIncidencia],
  //       incidencia.tipoIncapacidad == TipoIncapacidad.Ninguna ? '-' : this.tipoIncapacidad[incidencia.tipoIncapacidad],
  //       incidencia.observaciones
  //     ];

  //     return { datos: datosRenglon };
  //   });

  //   let totales: string[] = [];

  //   let datos: ArchivoExcel = {
  //     nombreArchivo: `${títulos.titulo1}.xlsx`,
  //     títulos: títulos,
  //     columnas: columnas,
  //     títuloColumnas: títuloColumnas,
  //     renglones: renglones,
  //     totales: totales,
  //     fuenteTítulo: undefined,
  //     fuenteRenglones: undefined,
  //     fuenteTotales: undefined,
  //   };

  //   creaArchivoExcel(datos, 'xxx');
  // }

  public async exportarPDF() {
    try {
      const { empresaImageBase64, logoAcceso } = await this.pdfService.obtenerImg(this.empresa);
      const rows = [];

      const headerRow = [
        { text: 'ID', style: 'tableHeader' },
        { text: 'Empleado', style: 'tableHeader' },
        { text: 'Inicio', style: 'tableHeader' },
        { text: 'Terminación', style: 'tableHeader' },
        { text: 'Tipo de movimiento', style: 'tableHeader' },
        { text: 'Horario especial', style: 'tableHeader' },
        { text: 'Días vacaciones', style: 'tableHeader' },
        { text: 'Tipo de incapacidad', style: 'tableHeader' },
        { text: 'Observaciones', style: 'tableHeader' },
      ];

      rows.push(headerRow);

      for (const incidencia of this.incidenciasUsuario) {
        const dataRow = [
          { text: `${incidencia.id}`, style: 'tableCell' },
          { text: `${incidencia.nombreEmpleado}`, style: 'tableCell' },
          { text: `${this.formatoFechaCorto(incidencia.inicio)}`, style: 'tableCell' },
          { text: `${this.formatoFechaCorto(incidencia.fin)}`, style: 'tableCell' },
          { text: `${this.tipoManejoIncidencia[incidencia.tipoManejoIncidencia]}`, style: 'tableCell' },
          { text: `${incidencia.horarioIncidencia == '' ? '-' : incidencia.horarioIncidencia}`, style: 'tableCell' },
          { text: `${incidencia.diasVacaciones == 0 ? '-' : incidencia.diasVacaciones}`, style: 'tableCell' },
          { text: `${incidencia.tipoIncapacidad == 0 ? '-' : this.tipoIncapacidad[incidencia.tipoIncapacidad]}`, style: 'tableCell' },
          { text: `${incidencia.observaciones}`, style: 'tableCell' },
        ];

        rows.push(dataRow);
      }

      const docDefinition = {
        pageOrientation: 'landscape',
        pageSize: 'letter',
        footer: (currentPage: number, pageCount: number) => {
          return {
             image: logoAcceso, width: 50, alignment: 'right',
            // columns: [
            //   { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', style: 'footer' },
            //   { image: logoNomi, width: 50, alignment: 'right' }
            // ],
            margin: [0, 10, 10, 0],
          };
        },
        content: [
          {
            columns: [
              { image: empresaImageBase64, width: 100, margin: [0, 0, 20, 0] },
              {
                stack: [
                  { text: `Validación de incidencias ${this.tipoIncidenciaSeleccionado != 100 ? 'de tipo ' + this.obtenerMovimiento(this.tipoIncidenciaSeleccionado) : ''}`, style: 'headerTitle', alignment: 'right' },
                   ...(this.tipoIncidenciaSeleccionado == 4 ? [{ text: `Total de días de vacaciones: ${this.diasTotalesVacaciones}`, style: 'headerDate', alignment: 'right' }] : []),
                  { text: `Fecha de expedición: ${this.formatoFecha(new Date())}`, style: 'headerDate', alignment: 'right' },
                  { text: `Periodo: ${this.formatoFecha(this.inicioPeriodo)} - ${this.formatoFecha(this.finPeriodo)}`, style: 'headerDate', alignment: 'right' },
                  { text: this.empresa.nombre, style: 'headerDate', alignment: 'right' },
                  { text: this.empresa.rfc, style: 'headerDate', alignment: 'right' },
                ],
                alignment: 'right'
              }
            ],
            margin: [0, 0, 0, 10]
          },
          {
            table: {
              headerRows: 1,
              widths: [20, 150, 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 150],
              body: rows,
            },
            layout: {
              fillColor: (rowIndex: number) => {
                return (rowIndex === 0) ? '#3498db' : (rowIndex % 2 === 0) ? '#f9f9f9' : '#ffffff';
              },
              hLineWidth: (i: number, node: any) => 0.5,
              vLineWidth: (i: number, node: any) => 0.5,
              hLineColor: (i: number, node: any) => '#bfbfbf',
              vLineColor: (i: number, node: any) => '#bfbfbf',
            },
            margin: [0, 0, 0, 20]
          },
        ],
        styles: {
          headerTitle: { fontSize: 16, bold: true, margin: [0, 0, 0, 5] },
          headerDate: { fontSize: 10, italics: true, margin: [0, 0, 0, 0] },
          footer: { fontSize: 10, italics: true, margin: [0, 0, 0, 10] },
          tableHeader: { bold: true, fontSize: 10, color: '#283593', alignment: 'center', fillColor: '#ffffff', margin: [0, 5, 0, 5] },
          tableCell: { fontSize: 8, alignment: 'center', margin: [0, 5, 0, 5] },
          faltasTabla: { fontSize: 8, alignment: 'center', margin: [0, 5, 0, 5], color: '#dc3545', fillColor: '#f8d7da' }
        }
      };

      const fileName = 'Validación_de_incidencias.pdf';
      pdfMake.createPdf(docDefinition).download(fileName);
    } catch (error) {
      console.error('Error al generar el PDF', error);
    }
  }

  public valueTipoIncidenciaAscOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return +this.tipoManejoIncidencia[+a.key] - +this.tipoManejoIncidencia[+b.key];
  };

  public cambiarPeriodo() {
    if (this.periodo != 'personalizado') console.log(`cambiarPeriodo. periodo: ${this.periodo}`);

    let inicio: Date = this.inicioPeriodo;
    let fin: Date = soloHoy();

    switch (this.periodo) {
      case 'hoy':
        inicio = soloHoy();
        break;
      case 'semana0':
        inicio = inicioSemanaActual();
        fin = addDays(inicio, 6);
        break;
      case 'semana1a':
        inicio = addDays(inicioSemanaActual(), -7);
        fin = addDays(inicio, 6);
        break;
      case 'quincena0':
        inicio = inicioQuincenaActual();
        if (inicio.getDay() == 1) {
          fin = addDays(inicio, 14);
        } else {
          fin = addDays(new Date(inicio.getFullYear(), inicio.getMonth() + 1, 1), -1);
        }
        break;
      case 'quincena1a':
        fin = addDays(inicioQuincenaActual(), -1);
        inicio = inicioQuincena(fin);
        break;
      case 'mes0':
        inicio = inicioMesActual();
        fin = addDays(new Date(inicio.getFullYear(), inicio.getMonth() + 1, 1), -1);
        break;
      case 'mes1a':
        fin = addDays(inicioMesActual(), -1);
        inicio = inicioMes(fin);
        break;
      case 'anioCompleto':
        inicio = new Date(inicioAnio().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
        fin = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        break;
      case 'anioActual':
        inicio = new Date(inicioAnio());
        fin = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        break;
      case 'anioAltaEmpleado':
        if (this.empleadoSeleccionado?.alta) {
          inicio = new Date(this.empleadoSeleccionado.alta);
          fin = new Date();
        } else {
          mostrarSwalError('Error', 'El empleado seleccionado no tiene una fecha de alta válida.');
          return;
        }
        break;
      case 'personalizado':
        inicio = this.rangoPersonalizado.value.desde ? this.rangoPersonalizado.value.desde : this.inicioPeriodo;
        fin = this.rangoPersonalizado.value.hasta ? this.rangoPersonalizado.value.hasta : this.finPeriodo;
        break;
      default:

        return;
    }

    if (inicio.getTime() > fin.getTime()) {
      fin = inicio;
    }

    if (this.inicioPeriodo.getTime() != inicio.getTime() || this.finPeriodo.getTime() != fin.getTime()) {
      console.log(`===========>>> Nuevo periodo: ${fFecha(inicio, 'fm')}, ${fFecha(fin, 'fm')} <<<<===========`);
      this.inicioPeriodo = inicio;
      this.finPeriodo = fin;
      this.accesoDatosService.guardarDatosRegistro(this.inicioPeriodo, this.finPeriodo, this.empleadoSeleccionado);
      this.cargarDatos();
      return;
    }

    this.calcularDiasVacaciones();
  }

  public compareFn(e1: IEmpleados, e2: IEmpleados): boolean {
    return e1 && e2 ? e1.id === e2.id : e1 === e2;
  }

  public handleCerrarIncidencias() {
    this.agregarIncidenciaMasiva = false;
    this.titleIncidencia = 'Validación de incidencias';
  }

  private obtenerHorarioEmpleado(idEmpleado: number, dia: Date): IHorarios | undefined {
    let horarioEmpleado: IHorariosEmpleado | undefined = this.horariosEmpleado.find(x => x.idEmpleado == idEmpleado);
    if (!horarioEmpleado) return undefined;
    if (horarioEmpleado.horarios.length > 0 && horarioEmpleado.horarios[0].detalles.length > 1) {
      horarioEmpleado.horarios[0].detalles = [horarioEmpleado.horarios[0].detalles[0]];
    }

    return horarioEmpleado.horarios.find(x => x.inicio <= dia && x.fin >= dia);
  }

  public cambiarTipoMovimiento() {
    if (!this.empleadoSeleccionado) {
      mostrarSwalError('Error', 'Debe seleccionar un empleado antes de continuar.');
      return;
    }
    if (this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.PermisoPorHoras || this.nuevaIncidencia.tipoManejoIncidencia == TipoManejoIncidencia.CambioTurno) {
      this.adjustDialogSize();
      const fechaInicio = fechaCV(this.inicioPersonalizado);
      const fechaFin = fechaCV(this.finPersonalizado);
      this.fechaValidacionTxt = obtenerDiaSemana(fechaInicio);
      let dia1: Date = fechaInicio;
      let dias: number = dateDiff(fechaInicio, fechaFin, TipoDateDiff.días) + 1;
      dia1 = soloDia(addDays(fechaInicio, dias - 1));
      let horario: IHorarios | undefined = this.obtenerHorarioEmpleado(+this.empleadoSeleccionado.id, dia1);
      if (!horario) {
        mostrarSwalError('Error', 'No se encontró un horario válido para el empleado seleccionado.');
        return;
      }
      this.horario = horario;
    }
  }

  private getToday(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  public onInicioChange() {
    this.finPersonalizado = this.inicioPersonalizado;
    this.calcularDias();
  }

  public obtenerHorario() {
    for (const incidencia of this.dataSource.data) {
      if (incidencia.tipoManejoIncidencia == TipoManejoIncidencia.PermisoPorHoras || incidencia.tipoManejoIncidencia == TipoManejoIncidencia.CambioTurno) {
        const fecha = incidencia.inicio instanceof Date ? incidencia.inicio : new Date(incidencia.inicio);
        const horarioInc = this.horariosIncidencias.find(h => h.idEmpleado == incidencia.idEmpleado && new Date(h.inicio).getTime() <= fecha.getTime() && new Date(h.fin).getTime() >= fecha.getTime());
        if (horarioInc && horarioInc.horario) {
          const horarioArray = JSON.parse(horarioInc.horario);
          if (horarioArray && horarioArray.length > 0) {
            incidencia.horarioIncidencia = horarioArray.map((h: any) => `${this.formatearHora(h.horaEntrada)} - ${this.formatearHora(h.horaSalida)}`).join(' | ');
          } else {
            incidencia.horarioIncidencia = 'Sin horario';
          }
        } else {
          incidencia.horarioIncidencia = 'Sin horario';
        }
      } else {
        incidencia.horarioIncidencia = '';
      }
    }
  }

  public calcularDiasVacaciones() {
    this.diasTotalesVacaciones = 0;
    for (const incidencia of this.dataSource.data) {
      if (incidencia.tipoManejoIncidencia == TipoManejoIncidencia.Vacaciones) {
        const fechaInicio = incidencia.inicio instanceof Date ? incidencia.inicio : new Date(incidencia.inicio);
        const fechaFin = incidencia.fin instanceof Date ? incidencia.fin : new Date(incidencia.fin);
        if (fechaInicio && fechaFin) {
          const diferencia = fechaFin.getTime() - fechaInicio.getTime();
          incidencia.diasVacaciones = Math.ceil(diferencia / (1000 * 3600 * 24)) + 1;
          this.diasTotalesVacaciones += incidencia.diasVacaciones;
        } else {
          incidencia.diasVacaciones = 0;
        }
      } else {
        incidencia.diasVacaciones = 0;
      }
    }
  }

  public formatearHora(value: number | undefined): string {
    if (value === undefined || value === null || value === 24) return '12:00 AM';
    let horas = Math.floor(value);
    let minutos = Math.round((value - horas) * 60);
    if (minutos === 60) {
        minutos = 0;
        horas += 1;
    }
    if (horas > 24) horas = horas - 24;
    const amPm = horas >= 12 ? 'PM' : 'AM';
    const horas12 = horas === 0 ? 12 : horas > 12 ? horas - 12 : horas;
    return `${horas12.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')} ${amPm}`;
  }

  public obtenerMovimiento(clave: number): string {
    if (!clave || clave == 100) return '';
    return this.tiposDeIncidencias[clave].toLowerCase();
  }

  public abrirDetalles(incidencia: IAccesoIncidenciasUsuario) {
    let incidenciasHorarioEmpleado: IHorariosIncidencias[] = this.horariosIncidencias.filter(x =>
      x.idEmpleado == incidencia.idEmpleado &&
      x.fin.getTime() >= incidencia.inicio.getTime() &&
      x.inicio.getTime() <= incidencia.fin.getTime()
    );
    let dia1: Date = incidencia.inicio;
    let horario: IHorarios | undefined = this.obtenerHorarioEmpleado(incidencia.idEmpleado, dia1);
    if (incidenciasHorarioEmpleado.length > 0) {
        let horarioIncidencia: IHorariosIncidencias | undefined = this.horariosIncidencias.find(x => x.idEmpleado == incidencia.idEmpleado && x.inicio <= dia1 && x.fin >= dia1)
        if (!!horarioIncidencia) {
          horario = new IHorarios();
          horario.idEmpleado = incidencia.idEmpleado;
          horario.idHorario = `Incidencia-${horarioIncidencia.id}-${incidencia.idEmpleado}-${fFecha(dia1, 'fc')}`;
          horario.tipoHorario = horarioIncidencia.manejoHorario.tipoHorario;
          horario.nombreHorario = 'Horario especial';
          horario.inicio = horarioIncidencia.inicio;
          horario.inicioTxt = horarioIncidencia.inicioTxt;
          horario.fin = horarioIncidencia.fin;
          horario.finTxt = horarioIncidencia.finTxt;
          horario.nocturno = horarioIncidencia.esNocturno;
          horario.detalles = convertirHorarioIncidenciaADetalle(horarioIncidencia, horarioIncidencia.manejoHorario, dia1);
          horario.manejoHorario = horarioIncidencia.manejoHorario;
        }
      }
    let diaIncidencia = obtenerDiaSemana(incidencia.inicio);

    this.dialog.open(HorarioDialogComponent, {
      data: {
        horario: horario,
        nombreEmpleado: incidencia.nombreEmpleado,
        diaIncidencia: diaIncidencia,
      },
      width: '65rem',
      height: '16rem',
      maxWidth: '100rem'
    });
  }

  public recibirIncidenciaCambio(incidencia: IHorariosIncidencias) {
    this.incidenciaCambio = incidencia;
  }

  get reportesParaMostrarGet() {
    return Object.entries(this.tipoManejoIncidencia)
      .filter(([key]) => !isNaN(+key))
      .map(([key, value]) => ({ key: +key, value }))
      .filter(entrada => this.esDebugger || entrada.key !== 11);
  }

  ngOnInit(): void {
    this.inicioPersonalizado = this.getToday();
    this.finPersonalizado = this.getToday();
    this.calcularDias();
    if (this.data) {
      this.empleadoSeleccionado = this.data.empleado;
      this.soloConsulta = this.data.soloConsulta;
      if (this.data.periodo) {
        this.periodo = this.data.periodo;
        if (this.periodo === 'personalizado' && this.data.inicio && this.data.fin) {
          this.inicioPeriodo = this.data.inicio;
          this.finPeriodo = this.data.fin;
        }
      }
    }

    this.changeDetectorRef.detectChanges();
    this.dataSource.paginator = this.paginator;
    this.incidenciasObs = this.dataSource.connect();
    this.aplicarFiltrosEmpleados();
    this.rangoPersonalizado.valueChanges.subscribe(values => {
      if (values.desde && values.hasta) {
        this.cambiarPeriodo();
      }
    });
  }
}
